import { addMonths } from "date-fns";

interface BillingCycle {
    startsAt: Date;
    endsAt: Date;
}

interface ResolveBillingCycleParams {
    periodStartsAt: Date;
    periodEndsAt: Date;
    now: Date;
}

interface EstimateProratedChargeParams {
    monthlyAmountCents: number;
    cycle: BillingCycle;
    now: Date;
}

export const resolveBillingCycle = ({
    periodStartsAt,
    periodEndsAt,
    now,
}: ResolveBillingCycleParams): BillingCycle => {
    if (periodEndsAt.getTime() > now.getTime()) {
        return { startsAt: periodStartsAt, endsAt: periodEndsAt };
    }

    let cyclesElapsed = 1;
    while (
        addMonths(periodStartsAt, cyclesElapsed + 1).getTime() <= now.getTime()
    ) {
        cyclesElapsed += 1;
    }

    return {
        startsAt: addMonths(periodStartsAt, cyclesElapsed),
        endsAt: addMonths(periodStartsAt, cyclesElapsed + 1),
    };
};

export const estimateProratedChargeCents = ({
    monthlyAmountCents,
    cycle,
    now,
}: EstimateProratedChargeParams): number => {
    const cycleMs = cycle.endsAt.getTime() - cycle.startsAt.getTime();
    const remainingMs = cycle.endsAt.getTime() - now.getTime();
    const remainingFraction = Math.min(Math.max(remainingMs / cycleMs, 0), 1);

    return Math.round(monthlyAmountCents * remainingFraction);
};
